export default function LevelControlDirective() {
  return {
    template: require('./level-control.html'),
    scope: {
      componentLevelId: '=',
      levelControl: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'LevelControlController',
    controllerAs: 'levelControlVM',
    bindToController: true,
    replace: true
  };
}
